export const PROVIDERS_TOKEN = ["focus"] as const;

export type Provider = (typeof PROVIDERS_TOKEN)[number];

export interface IAccessToken {
  provider: Provider;
  token: string;
}

export interface ILeadGoals {
  hour: string;
  goalQuantity: string;
}
export interface IContact {
  name: string;
  whatsapp: string;
}
export interface ICompanyContacts {
  operational: IContact;
  commercial: IContact;
}

export interface ICompany {
  _id?: string;
  socialname: string;
  fantasyname: string;
  cnpj: string;
  email: string;
  phone: string;
  address: Address;
  observations: Observation[];
  accessTokens: IAccessToken[];
  leadGoals: ILeadGoals[];
  createdAt: Date;
  updatedAt: Date;
  taxBurdens?: TaxBurdens;
  contacts?: ICompanyContacts;
}

export type TaxBurdens = {
  PIS: number;
  COFINS: number;
  IRPJ: number;
  ADIC: number;
  CSLL: number;
  ISS: number;
};

export type Address = {
  zipcode: string;
  street: string;
  number?: string | number;
  complement?: string;
  city: string;
  state: string;
  district: string;
  latitude?: number; // Geolocalização, opcional
  longitude?: number; // Geolocalização, opcional
};

export type Observation = {
  text: string;
  date: string;
  author: string;
};

export const emptyCompany = () =>
  ({
    _id: "",
    socialname: "",
    fantasyname: "",
    cnpj: "",
    email: "",
    phone: "",
    address: {
      zipcode: "",
      street: "",
      number: "",
      complement: "",
      city: "",
      state: "",
      district: "",
    },
    observations: [],
    accessTokens: [],
    leadGoals: [],
    createdAt: new Date(),
    updatedAt: new Date(),
    taxBurdens: {
      PIS: 0,
      COFINS: 0,
      IRPJ: 0,
      ADIC: 0,
      CSLL: 0,
      ISS: 0,
    },
    contacts: {
      operational: {
        name: "",
        whatsapp: "",
      },
      commercial: {
        name: "",
        whatsapp: "",
      },
    },
  } as ICompany);
